const TileCard = ({ children, className, border, boxShadow, onClick }) => (
  <div
    className={`tileCard-container px-4 py-3 ${className || ""}`}
    {...(onClick ? { onClick, style: { cursor: "pointer" } } : {})}
    style={{
      border: border || "1px solid rgba(0, 0, 0, 0.2)",
      boxShadow: boxShadow || "0px 4px 8px rgba(0, 0, 0, 0.05)",
      ...(onClick && { cursor: "pointer" }),
    }}
  >
    {children}
    <style>{`
        .tileCard-container {
          border-radius: 2px;
          position: relative;
        }
      `}</style>
  </div>
);
export default TileCard;  